var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5001 0C36.776 0 36.207 0.568965 36.207 1.2931V14.2241C36.207 14.9483 36.776 15.5172 37.5001 15.5172C38.2243 15.5172 38.7932 14.9483 38.7932 14.2241V1.2931C38.7932 0.568965 38.2243 0 37.5001 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5001 59.483C36.776 59.483 36.207 60.0519 36.207 60.7761V73.7071C36.207 74.4313 36.776 75.0002 37.5001 75.0002C38.2243 75.0002 38.7932 74.4313 38.7932 73.7071V60.7761C38.7932 60.0519 38.2243 59.483 37.5001 59.483Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7075 36.2068H60.7765C60.0524 36.2068 59.4834 36.7758 59.4834 37.4999C59.4834 38.224 60.0524 38.793 60.7765 38.793H73.7075C74.4317 38.793 75.0006 38.224 75.0006 37.4999C75.0006 36.7758 74.4317 36.2068 73.7075 36.2068Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5172 37.4999C15.5172 36.7758 14.9483 36.2068 14.2241 36.2068H1.2931C0.568965 36.2068 0 36.7758 0 37.4999C0 38.224 0.568965 38.793 1.2931 38.793H14.2241C14.9483 38.793 15.5172 38.224 15.5172 37.4999Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8794 53.0433C54.3622 52.5261 53.5604 52.5261 53.0432 53.0433C52.526 53.5606 52.526 54.3623 53.0432 54.8795L62.1984 64.0347C62.457 64.2933 62.7932 64.4226 63.1036 64.4226C63.4139 64.4226 63.776 64.2933 64.0087 64.0347C64.526 63.5175 64.526 62.7157 64.0087 62.1985L54.8794 53.0433Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8023 10.9909C12.285 10.4737 11.4833 10.4737 10.9661 10.9909C10.4488 11.5081 10.4488 12.3099 10.9661 12.8271L20.1212 21.9823C20.3798 22.2409 20.7161 22.3702 21.0264 22.3702C21.3367 22.3702 21.6988 22.2409 21.9316 21.9823C22.4488 21.465 22.4488 20.6633 21.9316 20.1461L12.8023 10.9909Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1212 53.0434L10.9661 62.1986C10.4488 62.7158 10.4488 63.5175 10.9661 64.0348C11.2247 64.2934 11.5609 64.4227 11.8712 64.4227C12.1816 64.4227 12.5436 64.2934 12.7764 64.0348L21.9316 54.8796C22.4488 54.3624 22.4488 53.5606 21.9316 53.0434C21.4402 52.552 20.6385 52.552 20.1212 53.0434Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9479 22.345C54.2841 22.345 54.6203 22.2157 54.853 21.9571L64.0082 12.8019C64.5255 12.2847 64.5255 11.4829 64.0082 10.9657C63.491 10.4484 62.6892 10.4484 62.172 10.9657L53.0168 20.1209C52.4996 20.6381 52.4996 21.4398 53.0168 21.9571C53.3013 22.2157 53.6375 22.345 53.9479 22.345Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.44f6d51214a7e3aebecc037d8dcf0928.svg";
export { ForwardRef as ReactComponent };